import { Component } from '@angular/core';
import { ConfigFacade } from '@library/store/config/config.facade';
import { UserFacade } from '@library/store/user/user.facade';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

type ViewModel = [string, string];

@Component({
  selector: 'app-legals-buttons',
  templateUrl: './legals-buttons.component.html',
  styleUrls: ['./legals-buttons.component.scss']
})
export class LegalsButtonsComponent {

  modalUrl = new BehaviorSubject<string>(null);
  modalUrl$ = this.modalUrl.asObservable();

  private viewUrl$ = this.configFacade.config$.pipe(
    filter(config => !!config),
    map(config => config.termsAndCondtionsUrl)
  );

  private country$ = this.userFacade.currentUser$.pipe(
    filter(user => !!user),
    map(user => user.country || 'US'),
  );

  viewModel$: Observable<ViewModel> = combineLatest([this.viewUrl$, this.country$]);

  constructor(
    private userFacade: UserFacade,
    private configFacade: ConfigFacade
  ) { }

  openPrivacy([viewUrl, country]: ViewModel): void {
    this.modalUrl.next(`${viewUrl}legals/magellan?read_only=true&country=${country}&goto=privacy`);
  }

  openTerms([viewUrl, country]: ViewModel): void {
    this.modalUrl.next(`${viewUrl}legals/magellan?read_only=true&country=${country}&goto=terms`);
  }

}
